const faqs = [
  {
    question: "Does Alaska have its own regional passport agency?",
    answer:
      "No — Alaska does not have a regional passport agency within state borders. The closest regional passport agency is the Seattle Passport Agency in Seattle, Washington — accessible by a 3–4 hour flight from Anchorage or a direct flight from Juneau, Ketchikan, and Sitka. Using a registered courier like Fast Passport Center is often far more practical for Alaskans, eliminating the need for a separate flight and agency appointment.",
  },
  {
    question: "How fast can I get a passport in Alaska?",
    answer:
      "With Fast Passport Center's courier service, Alaska travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Because Alaska is remote, courier service is especially valuable — you ship documents overnight to our processing team and we handle all agency submission.",
  },
  {
    question: "Do I need a passport to travel from Alaska to other U.S. states by air?",
    answer:
      "No — domestic flights within the U.S. (including Alaska to the lower 48 states) do not require a passport, though a REAL ID-compliant driver's license or state ID is required for TSA security. However, if you fly through Canada or travel to another country, a passport is required. Many Alaska-to-Seattle flights are considered domestic, but connecting internationally requires full passport documentation.",
  },
  {
    question: "Do Alaska residents need a passport to cross into Canada?",
    answer:
      "Yes — U.S. citizens need a passport book or passport card to cross the U.S.-Canada border by land or sea. For air travel to Canada, a passport book is required. Alaska shares a border with Canada (Yukon and British Columbia), and many Alaskans also travel the Alaska Highway or ferry routes that pass through Canadian territory.",
  },
  {
    question: "Can I renew my passport by mail from Alaska?",
    answer:
      "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, and is undamaged, you can renew by mail using Form DS-82. Ship your application to the National Passport Processing Center, or use Fast Passport Center's courier service for significantly faster processing without needing to fly to Seattle.",
  },
  {
    question: "Where is the best place to get a passport photo in Alaska?",
    answer:
      "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations in Anchorage, Fairbanks, Juneau, Ketchikan, Sitka, and Wasilla offer passport photo services. In remote communities, some post offices and community centers also provide photo services. Always verify the photo meets State Department requirements (2×2 inches, white background, taken within 6 months) before submitting.",
  },
];

export { faqs };

export default function AKFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Alaska Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Alaska.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}